import { Typography, makeStyles } from '@material-ui/core';

import { Trans, t } from '@lingui/macro';
import { i18n } from '@lingui/core';

import FixedLabelContainer, { Row, Label, Content, Line } from '../../fixed-label-container/FixedLabelContainer';
import PerformanceChart from '../../charts/performance-chart/PerformanceChart';
import { latencyDef, bandWidthFn, discardsErrorsFn } from './SiteChartDefs';
import VolumeRateUtilForm, { RATE } from '../../charts/ipm/VolumeRateUtilForm';
import useChartDisplayType from '../../../utilities/UseChartDisplayType';

const useStyles = makeStyles(() => ({
    fadeOnHoverTrigger: {
        '&:hover $fadeOnHover': {
            opacity: 1,
        },
    },
    fadeOnHover: {
        transitionProperty: 'opacity',
        transitionDuration: '0.2s',
        transitionTimingFunction: 'ease',
        opacity: 0,

        '@media print': {
            opacity: 1,
        },
    },
}));

const Bandwidth = ({ id, data }) => {
    const pageStateKey = `${id}-BandwidthType`;
    const [chartDisplayType, setChartDisplayType] = useChartDisplayType(pageStateKey, RATE);
    const classes = useStyles();

    return (
        <>
            <VolumeRateUtilForm
                className={classes.fadeOnHover}
                value={chartDisplayType}
                onChangeType={setChartDisplayType}
            />
            <PerformanceChart
                disableTimeAxis
                initialHeight={100}
                chartDef={bandWidthFn(chartDisplayType, i18n._(t`In`), i18n._(t`Out`))}
                data={data}
            />
        </>
    );
};

const DiscardsErrors = ({ id, data }) => {
    const pageStateKey = `${id}-DiscardsType`;
    const [chartDisplayType, setChartDisplayType] = useChartDisplayType(pageStateKey, RATE);
    const classes = useStyles();

    return (
        <>
            <VolumeRateUtilForm
                className={classes.fadeOnHover}
                value={chartDisplayType}
                onChangeType={setChartDisplayType}
                utilName="Percentage"
            />
            <PerformanceChart
                initialHeight={100}
                chartDef={discardsErrorsFn(
                    chartDisplayType,
                    i18n._(t`Discards In`),
                    i18n._(t`Discards Out`),
                    i18n._(t`Errors In`),
                    i18n._(t`Errors Out`)
                )}
                data={data}
            />
        </>
    );
};

export default function SiteWan({ id, data }) {
    const classes = useStyles();

    if (!data) return null;

    const latencyDeviceCount = data.siteLatencyCounts?.greenCount;
    const latencyText =
        latencyDeviceCount === 1 ? `(across ${latencyDeviceCount} device)` : `(across ${latencyDeviceCount} devices)`;

    return (
        <FixedLabelContainer>
            <Row>
                <Label>
                    <Trans>Latency</Trans> <Typography variant="caption">{latencyText}</Typography>
                </Label>
                <Content>
                    {/* This particular chart causes hovoc to sizing FixedLabelContainer::Lable (it expands 15px) */}
                    <PerformanceChart
                        disableTimeAxis
                        initialHeight={100}
                        chartDef={latencyDef(i18n._(t`Average`), i18n._(t`Minimum`))}
                        data={data}
                    />
                </Content>
            </Row>
            <Line />
            <Row className={classes.fadeOnHoverTrigger}>
                <Label>
                    <Trans>Bandwidth</Trans>
                </Label>
                <Content>
                    <Bandwidth id={id} data={data} />
                </Content>
            </Row>
            <Line />
            <Row className={classes.fadeOnHoverTrigger}>
                <Label>
                    <Trans>Discards/Errors</Trans>
                </Label>
                <Content>
                    <DiscardsErrors id={id} data={data} />
                </Content>
            </Row>
        </FixedLabelContainer>
    );
}
